import PaymentLinkGenerated, { PaymentLinkGeneratedEntityManager } from './generated/PaymentLink.generated';
import { BusinessEntityFieldType } from '@xFrame4/business/base/Constants';
import { imageInfoGraphQlDetails } from '@xFrame4/business/Constants';
import { YouTubeVideoInfo, ImageInfo } from '@xFrame4/business/Types';
import ImageGallery, { GalleryImage } from '@xFrame4/business/images/ImageGallery';
import client from '@xFrame4/business/GraphQlClient';

export const PAYMENT_LINK_ORDER_ID_PREFIX = 'pl__';

export class PaymentLinkEntityManager extends PaymentLinkGeneratedEntityManager<PaymentLink>
{
    constructor()
    {
        super({
            createEntity: () => new PaymentLink(),
            fields: [
                { name: 'paymentLinkUrl', type: BusinessEntityFieldType.VarChar, isInput: false }
            ]
        });
    }
}


export class PaymentLink extends PaymentLinkGenerated
{
    static _manager: PaymentLinkEntityManager;
    static get manager(): PaymentLinkEntityManager
    {
        if (!this._manager) this._manager = new PaymentLinkEntityManager();
        return this._manager;
    }

    /** The full URL for the payment link */
    paymentLinkUrl!: string;

    /**
     * Get payment link by unique ID.
     * Public method - no authentication required.
     *
     * Args:
     *     uniqueLinkId: The unique link ID to search for
     *
     * Returns:
     *     Promise<PaymentLink | null> - The payment link object or null if not found
     */

    static async getPaymentLinkByUniqueId(uniqueLinkId: string): Promise<PaymentLink | null>
    {
        // Dynamically import the gql to speed up the initial loading
        const { gql } = await import('@apollo/client');

        let query = `
            query GetPaymentLinkByUniqueId($uniqueLinkId: String!) {
                getPaymentLinkByUniqueId(uniqueLinkId: $uniqueLinkId) {
                    ...PaymentLinkDetailsFragment
                }
            }
            ${PaymentLink.manager.buildEntityDetailsFragment()}
        `;

        try
        {
            let { data } = await client.query({
                query: gql(query),
                variables: { uniqueLinkId }
            });
            
            if (data?.getPaymentLinkByUniqueId)
            {
                return PaymentLink.manager.createFromGraphQL(data.getPaymentLinkByUniqueId) as PaymentLink;
            }
            
            return null;
        }
        catch (error)
        {
            console.error('Error fetching payment link by unique ID:', error);

            return null;
        }
    }
}


export default PaymentLink;